import { SelectActiveUserGroupWithBranchNameOutputData } from './select-active-user-group-with-branch-name-output-data.model';


export class SelectActiveUserGroupWithBranchNameOutput implements ISelectActiveUserGroupWithBranchNameOutput {
    status!: number;
    message!: string;
    data!: SelectActiveUserGroupWithBranchNameOutputData[];

    constructor(data?: ISelectActiveUserGroupWithBranchNameOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SelectActiveUserGroupWithBranchNameOutputData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SelectActiveUserGroupWithBranchNameOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SelectActiveUserGroupWithBranchNameOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISelectActiveUserGroupWithBranchNameOutput {
    status: number;
    message: string;
    data: SelectActiveUserGroupWithBranchNameOutputData[];
}

